import {
  EyeOutlined,
  DeleteOutlined,
  FileImageOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  theme,
  Card,
  Skeleton,
  Button,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect } from "react";
import Heading from "../../../../../components/common/heading";
import TableNameListView from "../view/tableView";
import {MultipleAutoComplete} from "../../../../../components/common/autoCompleteV2";
import { formatDateBE } from "../../../../../lib/utils/date";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export const convertCountry = (keytext, data) => {
  let text = "";

  data.map((Item) => {
    if (Item.countryId === keytext) {
      text = Item.countryNameTh;
    }
  });
  return text;
};

export const convertMasterData = (keytext, data) => {
  let text = "";
  data.map((Item) => {
    if (Item.dataId === keytext) {
      text = Item.dataDetailTh;
    }
  });
  console.log(text)
  return text;
};

const FutureDetailView = (props) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const {
    dataDetail,
    getCountry,
    dropDownAreaType,
    dropDownAreaType_v2,
    dropDownCompanyType,
    dropDownCurerntStatus,
    dropDownCurerntStatus_v2,
    dropDownIndustryType,
    dropDownRegionGroup,
    dropDownRegionType,
    countMonth,
    dropDownIndustryType_v2,
    onPreviewFile = () => {},    
    
    items,
    thumbs,
  } = props;

  const [otherTopicDefined, setOtherTopicDefined] = React.useState(false);
  const [otherDetails, setOtherDetails] = React.useState("");
  const [displayTopic, setDisplayTopic] = React.useState("");

  useEffect(() => {
    if (dataDetail?.topicList) {
      let concatenatedTopicName = "";
      // dataDetail.topicList.map((item,i) => {
      //   concatenatedTopicName.concat((i!=0? ",":""));
      //   concatenatedTopicName.concat(item.topicName);
      //   if (item.topicId === "965a18a0-1029-410b-9900-1c1d1c1fea47") {
      //     setOtherTopicDefined(true);
      //     setOtherDetails(item.topicOther);
      //   }
      // });
      for (let i = 0; i < dataDetail.topicList.length; i++) {
        let item = dataDetail.topicList[i];
        
        concatenatedTopicName = concatenatedTopicName.concat(i !== 0 ? ", " : "");
        concatenatedTopicName = concatenatedTopicName.concat(item.topicName);
        
        if (item.topicId === "965a18a0-1029-410b-9900-1c1d1c1fea47") {
          setOtherTopicDefined(true);
          setOtherDetails(item.topicOther);
        }
      }
      setDisplayTopic(concatenatedTopicName);
    }
  }, [dataDetail]);

  useEffect(() => {
  }, [displayTopic]);

  return (
    <Content>
      <Row gutter={[8, 16]} className="card">
        <Col span={24}>
          <Heading
            text={"ข้อมูลลูกค้าอนาคต"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
        <Col span={16}>
          <Form.Item
            label={
              <Text className="pr_green">
                เลขทะเบียนพาณิชย์ (DBD Register number)
              </Text>
            }
            name={"dbdRegisterNumber"}
          >
            <Text>
              {dataDetail.dbdRegisterNumber
                ? dataDetail.dbdRegisterNumber
                : "-"}
            </Text>
          </Form.Item>
        </Col>

        <Col span={16}>
          <Form.Item
            label={
              <Text className="pr_green">
                ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)
              </Text>
            }
            name={"topicList"}
          >
            <Text>
              {displayTopic
                ? displayTopic
                : "-"}
            </Text>
          </Form.Item>
        </Col>

        {/* check if otherTopicDefined is true, if true then display topicOther */}
        {otherTopicDefined && (
          <Col span={16}>
            <Form.Item
              label={
                <Text className="pr_green">
                  รายละเอียด (อื่นๆ)
                </Text>
              }
              name={"topicOther"}
            >
              <Text>
                {otherDetails
                  ? otherDetails
                  : "-"}
              </Text>
            </Form.Item>
          </Col>
        )}

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label={<Text className="pr_green">ปีงบประมาณ</Text>}
                name={"yearOfBudget"}
              >
                <Text>
                  {dataDetail.yearOfBudget
                    ? parseInt(dataDetail.yearOfBudget) + 543
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <Text className="pr_green">วัน/เดือน/ปี ที่รับลูกค้า</Text>
                }
                name={"DateFromTo"}
              >
                <Text>
                  {dataDetail.fromDate
                    ? formatDateBE(dataDetail.fromDate, "DD/MM/YYYY")
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label={<Text className="pr_green">สถานะปัจจุบัน</Text>}
                name={"currentStatus"}
              >
                <Text>
                  {dataDetail.currentStatus
                    ? convertMasterData(
                        dataDetail.currentStatus,
                        dropDownCurerntStatus == "" ? dropDownCurerntStatus
                        : dropDownCurerntStatus_v2
                      )
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<Text className="pr_green">Lead Time</Text>}
                name={"LeadTime"}
              >
                <Text>{countMonth || "-"} เดือน</Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green" name={"isInvestmentAdvice"}>
                    วัตถุประสงค์ขอคำปรึกษาด้านการลงทุน
                  </Text>
                }
              >
                <Text strong>
                  {dataDetail.isInvestmentAdvice ? "ใช่" : "ไม่ใช่"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green" name={"isVisitAreaLandInfo"}>
                    วัตถุประสงค์เยี่ยมชมพื้นที่/สอบถามข้อมูลที่ดิน
                  </Text>
                }
              >
                <Text strong>
                  {dataDetail.isVisitAreaLandInfo ? "ใช่" : "ไม่ใช่"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green" name={"isAskForApprove"}>
                    วัตถุประสงค์สอบถามอนุมัติ/อนุญาต
                  </Text>
                }
              >
                <Text strong>
                  {dataDetail.isAskForApprove ? "ใช่" : "ไม่ใช่"}
                </Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={16}>
          <Form.Item
            label={
              <Text className="pr_green">วัตถุประสงค์ในการติดต่ออื่นๆ</Text>
            }
            name={"otherPurposes"}
          >
            <Text>
              {dataDetail.otherPurposes ? dataDetail.otherPurposes : "-"}
            </Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">ประเภทการจัดตั้งบริษัท</Text>}
            name={"companyType"}
          >
            <Text>
              {dataDetail.companyType
                ? convertMasterData(dataDetail.companyType, dropDownCompanyType)
                : "-"}
            </Text>
          </Form.Item>
        </Col>
        <Divider style={{ margin: 0 }} />

        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">ชื่อบริษัท (TH)</Text>}
            name={"companyNameTh"}
          >
            <Text>
              {dataDetail.companyNameTh ? dataDetail.companyNameTh : "-"}
            </Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">ชื่อบริษัท (EN)</Text>}
            name={"companyNameEn"}
          >
            <Text>
              {dataDetail.companyNameEn ? dataDetail.companyNameEn : "-"}
            </Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">ที่อยู่บริษัท</Text>}
            name={"address"}
          >
            <Text>{dataDetail.address ? dataDetail.address : "-"}</Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">Website บริษัท</Text>}
            name={"website"}
          >
            <Text>{dataDetail.website ? dataDetail.website : "-"}</Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">สัญชาติบริษัท</Text>}
            name={"nationalIds"}
          >
            {/* <Text>{dataDetail.nationalIds ? convertCountry(dataDetail.nationalIds, getCountry) : "-"}</Text> */}
            {dataDetail.nationalIds?.map((item, i) => {
              return (
                <>
                  <Text>{convertCountry(item, getCountry)}</Text>
                  <br />
                </>
              );
            })}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.List name="tableNameList">
            {() => {
              return (
                <TableNameListView
                  dataDetail={dataDetail.futureCustomerMembers}
                ></TableNameListView>
              );
            }}
          </Form.List>
        </Col>

        <Col span={16}>
          <Form.Item
            label={<Text className="pr_green">อุตสาหกรรมปัจจุบัน</Text>}
            name={"currentIndustry"}
          >
            <Text>
              {dataDetail.currentIndustry ? dataDetail.currentIndustry : "-"}
            </Text>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label={
              <Text className="pr_green">
                อุตสาหกรรมที่ต้องการดำเนินการในพื้นที่ กนอ.
              </Text>
            }
            name={"ieatIndusrty"}
          >
            <Text>
              {dataDetail.ieatIndusrty ? dataDetail.ieatIndusrty : "-"}
            </Text>
          </Form.Item>
        </Col>

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ประเภทอุตสาหกรรม
                  </Text>
                }
                name={"industryTypeIds"}
              >
                {/* {dataDetail.industryTypeIds?.map((item, i) => {
                  return (
                    <>
                      <Text>
                        {item
                          ? convertMasterData(
                              item,
                              dropDownIndustryType == "" ? dropDownIndustryType
                              : dropDownIndustryType_v2
                            )
                          : "-"}

                      
                      </Text>
                      <br />
                    </>
                  );
                })} */}
                {dataDetail.industryTypeIds?.map((item, i) => {
                  const v2 = item ? convertMasterData(item, dropDownIndustryType_v2) : "";
                  const old = item ? convertMasterData(item, dropDownIndustryType) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}-${i}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<Text className="pr_green">เงินลงทุนธุรกิจ</Text>}
                name={"investmentAmount"}
              >
                <Text>
                  {dataDetail.investmentAmount
                    ? dataDetail.investmentAmount
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ประเภทพื้นที่ที่ลูกค้าต้องการ
                  </Text>
                }
                name={"areaTypeIds"}
              >
                {/* <Text>
                  {dataDetail.regionTypeIds
                    ? dataDetail.regionTypeIds
                    : "-"}
                </Text> */}
                {/* {dataDetail.areaTypeIds?.map((item, i) => {
                  return (
                    <>
                      <Text>
                        {item ? convertMasterData(item, dropDownAreaType) : "-"}
                      </Text>
                      <Text>
                        {
                          item
                            ? convertMasterData(
                                item,
                                dropDownAreaType == "" ? dropDownAreaType
                                : dropDownAreaType_v2
                              )
                            : "-"
                        }
                      </Text>
                      <br />
                    </>
                  );
                })} */}

                {dataDetail.areaTypeIds?.map((item, i) => {
                  const v2 = item ? convertMasterData(item, dropDownAreaType_v2) : "";
                  const old = item ? convertMasterData(item, dropDownAreaType) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}-${i}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}

              </Form.Item>
            </Col>
            <Col span={12}></Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">ขนาดพื้นที่ที่ต้องการ (ไร่)</Text>
                }
                name={"areaSizeRai"}
              >
                <Text>
                  {dataDetail.areaSizeRai ? dataDetail.areaSizeRai : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">ขนาดพื้นที่ที่ต้องการ (งาน)</Text>
                }
                name={"areaSizeNgan"}
              >
                <Text>
                  {dataDetail.areaSizeNgan ? dataDetail.areaSizeNgan : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">ขนาดพื้นที่ที่ต้องการ (วา)</Text>
                }
                name={"areaSizeWa"}
              >
                <Text>
                  {dataDetail.areaSizeWa ? dataDetail.areaSizeWa : "-"}
                </Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ขนาดโรงงานมาตรฐานที่ต้องการ (ตารางเมตร)
                  </Text>
                }
                name={"areaSizeMeter"}
              >
                <Text>
                  {dataDetail.areaSizeMeter ? dataDetail.areaSizeMeter : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ปริมาณการใช้ไฟฟ้า (กิโลวัตต์)
                  </Text>
                }
                name={"kwAmount"}
              >
                <Text>{dataDetail.kwAmount ? dataDetail.kwAmount : "-"}</Text>
              </Form.Item>
            </Col>
            {false && (
            <Col span={8}>
              <Form.Item
                label={<Text className="pr_green">พื้นที่ที่ลูกค้าสนใจลงทุน</Text>}
                name={"areaSizeRecommend"}
              >
                <Text>
                  {dataDetail.areaSizeRecommend
                    ? dataDetail.areaSizeRecommend
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
            )}
            <Col span={8}>
              <Form.Item
                label={<Text className="pr_green">ภูมิภาคที่ลูกค้าสนใจลงทุน</Text>}
                name={"regionTypeIds"}
              >
                {/* <Text>
                  {dataDetail.regionTypeIds
                    ? dataDetail.regionTypeIds
                    : "-"}
                </Text> */}
                {(dataDetail.regionTypeIds ?? [])
                .map((raw, i) => {
                  const item = (raw ?? "").trim();
                  const label = item ? convertMasterData(item, dropDownRegionType) : "-";

                  return (
                    <Text key={`${item || "empty"}-${i}`}>
                      {label || "-"}
                    </Text>
                  );
                })}

              </Form.Item>
            </Col> 
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ปริมาณการใช้น้ำประปา ลูกบาศก์เมตร/วัน (ลบ.ม./วัน)
                  </Text>
                }
                name={"waterConsumptionAmount"}
              >
                <Text>
                  {dataDetail.waterConsumptionAmount
                    ? dataDetail.waterConsumptionAmount
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ปริมาณน้ำ​เสีย ลูกบาศก์เมตร (ลบ.ม.)
                  </Text>
                }
                name={"wasteWaterAmount"}
              >
                <Text>
                  {dataDetail.wasteWaterAmount
                    ? dataDetail.wasteWaterAmount
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <Text className="pr_green">
                    ปริมาณดิบน้ำ​ ลูกบาศก์เมตร (ลบ.ม.)
                  </Text>
                }
                name={"untreatedWaterAmount"}
              >
                <Text>
                  {dataDetail.untreatedWaterAmount
                    ? dataDetail.untreatedWaterAmount
                    : "-"}
                </Text>
              </Form.Item>
            </Col>
             <Row gutter={[12, 12]}>
              {items.map((it) => {
                const th = thumbs[it.path];
                const isPdf = th?.isPdf || it.fileName?.toLowerCase().endsWith(".pdf");
                return (
                  <Col key={it.uid || it.path} xs={24} sm={12} md={8} lg={8} xl={6}>
                    <Card
                      hoverable
                      bodyStyle={{ padding: 8 }}
                      cover={
                        <div
                          style={{
                            width: "100%",
                            aspectRatio: "4/3",
                            overflow: "hidden",
                            background: "#f5f5f5",
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                          }}
                          onClick={() => onPreviewFile(it.path)}
                        >
                          {isPdf ? (
                            <FilePdfOutlined style={{ fontSize: 48, color: "#9f1239" }} />
                          ) : th?.src ? (
                            <img
                              src={th.src}
                              alt={it.fileName}
                              style={{ maxWidth: "100%", maxHeight: "100%" }}
                            />
                          ) : (
                            <Skeleton.Image active style={{ width: "60%", height: "60%" }} />
                          )}

                          <Button
                            type="text"
                            icon={<EyeOutlined />}
                            style={{ position: "absolute", top: 8, right: 8 }}
                            onClick={(e) => { e.stopPropagation(); onPreviewFile(it.path); }}
                          />
                        </div>
                      }
                    >
                      <div style={{ fontSize: 12, color: "#666", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
                        {it.fileName}
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default FutureDetailView;
